import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../contexts/UserAuthContext";

const AUTH_PATHS = new Set([
  "/login",
  "/forgot-password",
  "/reset-password",
]);

const isExcludedPath = (pathname) => {
  if (!pathname) return true;
  if (pathname === "/onboarding/shopping-profile") return true;
  if (AUTH_PATHS.has(pathname)) return true;
  if (pathname.startsWith("/admin") || pathname.startsWith("/superadmin")) {
    return true;
  }
  return false;
};

const ShoppingProfileOnboardGate = ({ children }) => {
  const { user, userAuthChecked } = useUserAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userAuthChecked || !user) return;
    if (isExcludedPath(location.pathname)) return;
    if (!user.needsShoppingProfileOnboarding) return;

    navigate("/onboarding/shopping-profile", {
      replace: true,
      state: { from: location.pathname + location.search },
    });
  }, [
    user,
    userAuthChecked,
    location.pathname,
    location.search,
    navigate,
  ]);

  return children;
};

export default ShoppingProfileOnboardGate;
